import React from 'react'
import { SvgRemove } from '@chilipiper/icons/src/design-system/Remove'
import { ScreenReaderOnly } from '../../../new/core-components'
import { Props as ButtonProps } from '../Button'
import { StyledButton, StyledIcon } from './styles'

export const CellRemove = (props: ButtonProps) => (
  <StyledButton display='flex' alignItems='center' justifyContent='center' px={5} py={4} {...props}>
    <StyledIcon icon={SvgRemove} color={props.disabled ? 'icon/disabled' : 'icon/action-minor'} />
    <ScreenReaderOnly>Remove</ScreenReaderOnly>
  </StyledButton>
)
